<template>
  <div>
    <div v-if="activeDrivers">
      <h3>List of TC Active Users</h3>
      <table style="width:600px">
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Badge</th>
          <th>Username</th>
          <th>Pic</th>
          <th>TCPortal</th>
        </tr>

        <tr v-for="driver in activeDrivers" :key="driver.id">
          <td>{{driver.id}}</td>
          <td>{{driver.first_name}} {{driver.last_name}}</td>
          <td>{{driver.data.operator_nbr}}</td>
          <td>{{driver.username}}</td>
          <td>{{driver.data.license_nbr}}</td>
          <td><a 
            :href="`${baseURL}/#/login?companyId=3405&username=${driver.username}&password=${driver.data.license_nbr}`"
            target="_blank">
            {{driver.username}}</a>↗︎
          </td>
          <td><button @click="operatorStore.createOperator(driver.id)">Create Operator</button></td>
        </tr>
      </table>
      <p>
        Convienience links: 
        <a href="http://admin.taxicaller.net/admin/users.php" target="_blank">TC Admin - Users</a>↗︎
      </p>
    </div>
    <div v-else>
      ... Loading
    </div>
  </div>
</template>

<script>
export default {
  name:"TCUsers",
  inject: ['operatorPage'],
  data(){
    return {
      // baseURL: webpackHotUpdate ? 'http:localhost:8081' : 'https://driver.tcportal.ca'
      baseURL: 'https://driver.tcportal.ca',
    }
  },
  computed:{
    operatorStore(){
      return this.operatorPage.$refs.operatorStore
    },
    activeDrivers(){
      return this.operatorStore.activeDrivers
    }
  },
}
</script>